import { Component, ViewChild, ElementRef, Input } from '@angular/core';



declare const Chart: any;

@Component({
    selector: 'chartjs-piechart',
    templateUrl: './piechart.component.html',
    styleUrls: ['./piechart.component.css']
})



export class PiechartComponent {
    public chart: any;
    public elemId = 'chartjs-canvas-' + Math.random();

    @Input() _data: any = {
        labels: [""],
        data: [],
        title: []
    }
    @Input() _height: number = 200


    ngOnInit() {
        setTimeout(() => {
            this.loadChart();
        }, 500);

    }
    loadChart() {
        const options = {
           
            type: 'doughnut',
            options: {
                legend: {
                   display: false //This will do the task
                }
             },
            data: {
               labels: this._data.labels,
          
                datasets: [{

                    label: this._data.title,
                    data: this._data.data,
                    //   label: 'My First Dataset',
                    //   data: [300,  100],
                    // cutout: Math.max.apply(0, this._data.data),
                   
                    backgroundColor: [

                        // "rgba(27, 128, 184)",
                        // 'rgb(92, 133, 214 )',
                        'rgb(227, 97, 65)',
                        'rgb(127, 156, 28)',
                        'rgb(255, 99, 132)',
                        'rgb(79, 97, 137)',
                        'rgb(173, 105, 173)',
                        'rgb( 78, 187, 173 )',
                        'rgb(198, 41, 41)',
                        'rgb(51, 102, 204)'
                    ],
                  
                    hoverOffset: 4
                }]
            }
          
        };


        this.chart = new Chart(this.elemId, options);
    }
}

